var _rect, _rect2, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCareerBgSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1437,
    height: 716,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1089,
    y: 90,
    width: 5,
    height: 31,
    rx: 2.5,
    transform: "rotate(-180 1089 90)",
    fill: "#F9DB6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1071,
    y: 77,
    width: 5,
    height: 31,
    rx: 2.5,
    transform: "rotate(-90 1071 77)",
    fill: "#F9DB6D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1202.5,
    cy: 563.5,
    r: 15,
    transform: "rotate(-180 1202.5 563.5)",
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1311.5,
    cy: 302.5,
    r: 15,
    transform: "rotate(-180 1311.5 302.5)",
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQzNyIgaGVpZ2h0PSI3MTYiIHZpZXdCb3g9IjAgMCAxNDM3IDcxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTA4OSIgeT0iOTAiIHdpZHRoPSI1IiBoZWlnaHQ9IjMxIiByeD0iMi41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDEwODkgOTApIiBmaWxsPSIjRjlEQjZEIi8+CjxyZWN0IHg9IjEwNzEiIHk9Ijc3IiB3aWR0aD0iNSIgaGVpZ2h0PSIzMSIgcng9IjIuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDEwNzEgNzcpIiBmaWxsPSIjRjlEQjZEIi8+CjxjaXJjbGUgY3g9IjEyMDIuNSIgY3k9IjU2My41IiByPSIxNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAxMjAyLjUgNTYzLjUpIiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS1vcGFjaXR5PSIwLjA3IiBzdHJva2Utd2lkdGg9IjciLz4KPGNpcmNsZSBjeD0iMTMxMS41IiBjeT0iMzAyLjUiIHI9IjE1IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDEzMTEuNSAzMDIuNSkiIHN0cm9rZT0iIzMzODg3NyIgc3Ryb2tlLW9wYWNpdHk9IjAuMDciIHN0cm9rZS13aWR0aD0iNyIvPgo8L3N2Zz4K";
export { SvgCareerBgSvg as ReactComponent };